import ApprovalTable from "./components/ApprovalTable";
import { useLocation } from "react-router-dom";
import { TabMenu } from "@/types/Shared/tab";
import CommonTab from "@/components/Common/Tab";
import ContentLayout from "@/layouts/ContentLayout";

export default function ApprovalResponseManagement() {
  const { state } = useLocation();
  const tabData: TabMenu[] = [
    {
      label: "승인 요청",
      path: "/approvals/requests",
    },
    {
      label: "승인 응답",
      path: "/approvals/responses",
    },
  ];

  return (
    <ContentLayout>
      <CommonTab variants="string" data={tabData} state={state} />

      <div className="mt-5 bg-white border border-gray-D rounded-xl">
        <ApprovalTable />
      </div>
    </ContentLayout>
  );
}
